import ReactAsyncSelect from 'react-select/async'

const AsyncSelect = (props) => {
  const { onLoadOptions, ...rest } = props
  const menuPortalTarget =
    typeof document === 'undefined' ? undefined : document.body

  return (
    <ReactAsyncSelect
      cacheOptions
      defaultOptions
      loadOptions={onLoadOptions}
      menuPortalTarget={menuPortalTarget}
      menuPosition="fixed"
      styles={{
        menuPortal: (base) => ({
          ...base,
          zIndex: 100,
        }),
        menu: (base) => ({
          ...base,
          zIndex: 100,
        }),
      }}
      {...rest}
    />
  )
}

export default AsyncSelect
